import React, { memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Checkbox, Chip, IconButton, MenuItem, RadioButton, RadioButtonGroup, SelectField, TextField, Toggle } from 'material-ui';
import _ from 'lodash';

import { updateTcOrder } from 'actions/tc/orders';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import TypeByPurpose from '../../../../Vessels/Single/Rows/TypeByPurpose';
import TypeBySpecialty from '../../../../Vessels/Single/Rows/TypeBySpecialty';
import TypeByConstruction from '../../../../Vessels/Single/Rows/TypeByConstruction';
import Flag from '../../../../Vessels/Single/Rows/Flag';
import RegisterClassMulti from '../../../../Vessels/Single/Rows/RegisterClassMulti';
import GearV2 from '../../../../Vessels/Single/Rows/GearV2';
import GrabV2 from '../../../../Vessels/Single/Rows/GrabV2';

import VesselTypeSizes from '../VesselTypeSizes';

import { imoClassNames, imoAppNames, iceClassNames, fitted } from 'constants/vesselRequirements';
import GearedGrabbed from 'components/Vessels/Single/Rows/GearedGrabbed';

const styles = {
    radioButton: {
        marginBottom: 16,
    },
    redioGroup: {
        display: 'flex',
    },
    checkbox: {
        marginTop: '30px',
    },
    add: {
        marginTop: '25px',
        display: 'flex',
        justifyContent: 'center',
    },
    chips: {
        margin: '8px 8px 0 0',
    },
};

const defaultGearV2 = {
    summary: [
        {
            type: null,
            quantity: null,
            capacity: null,
            outreach: null,
            maxSWL: null,
            combinable: false,
        },
    ],
};

const defaultGrabV2 = {
    summary: [
        {
            type: null,
            quantity: null,
            volume: null,
        },
    ],
};

const defaultSelectedCountry = {
    flag: { _id: null, name: null },
    excluded: false,
};

class VesselRequirements extends React.PureComponent {
    state = {
        selectedCountry: defaultSelectedCountry,
        dwtMinError: '',
        dwtMaxError: '',
        capacityMinError: '',
        capacityMaxError: '',
        teuMinError: '',
        teuMaxError: '',
        linerMeterMinError: '',
        linerMeterMaxError: '',
        ageMinError: '',
        ageMaxError: '',
    };

    changeField = (changes) => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        const that = this;
    
        const change = {};
        changes.forEach(({ field, value }) => {
            if (!field) return;

            if (_.has(that.state, [`${field}Error`])) {
                switch (field) {
                case 'dwtMin':
                    if (!value) {
                        change.dwtMinError = 'Min dwt is required';
                    } else if (value > _tcOrder.vesselRequirements.dwtMax) {
                        change.dwtMinError = 'Min is greater than max';
                    } else if (value <= _tcOrder.vesselRequirements.dwtMax) {
                        change.dwtMinError = '';
                        change.dwtMaxError = '';
                    } else {
                        change.dwtMinError = '';
                    }
                    break;
                case 'dwtMax':
                    if (!value) {
                        change.dwtMaxError = 'Max dwt is required';
                    } else if (value < _tcOrder.vesselRequirements.dwtMin) {
                        change.dwtMaxError = 'Max is less than min';
                    } else if (value >= _tcOrder.vesselRequirements.dwtMin) {
                        change.dwtMaxError = '';
                        change.dwtMinError = '';
                    } else {
                        change.dwtMaxError = '';
                    }
                    break;
                case 'capacityMin':
                    if (value > _tcOrder.vesselRequirements.capacityMax) {
                        change.capacityMinError = 'Min is greater than max';
                    } else if (value <= _tcOrder.vesselRequirements.capacityMax) {
                        change.capacityMinError = '';
                        change.capacityMaxError = '';
                    } else {
                        change.capacityMinError = '';
                    }
                    break;
                case 'capacityMax':
                    if (value < _tcOrder.vesselRequirements.capacityMin) {
                        change.capacityMaxError = 'Max is less than min';
                    } else if (value >= _tcOrder.vesselRequirements.capacityMin) {
                        change.capacityMaxError = '';
                        change.capacityMinError = '';
                    } else {
                        change.capacityMaxError = '';
                    }
                    break;
                case 'teuMin':
                    if (value > _tcOrder.vesselRequirements.teuMax) {
                        change.teuMinError = 'Min is greater than max';
                    } else if (value < _tcOrder.vesselRequirements.teuMax) {
                        change.teuMinError = '';
                        const { teuMax } = _tcOrder.vesselRequirements;
                        if (teuMax && (teuMax >= 50 && teuMax <= 30000)) {
                            change.teuMaxError = '';
                        }
                    } else {
                        change.teuMinError = '';
                    }

                    if (value && (value < 50 || value > 30000)) {
                        change.teuMinError = '50 - 30000';
                    }
                    break;
                case 'teuMax':                    
                    if (value < _tcOrder.vesselRequirements.teuMin) {
                        change.teuMaxError = 'Max is less than min';
                    } else if (value > _tcOrder.vesselRequirements.teuMin) {
                        change.teuMaxError = '';
                        const { teuMin } = _tcOrder.vesselRequirements;
                        if (teuMin && (teuMin >= 50 && teuMin <= 30000)) {
                            change.teuMinError = '';
                        }
                    } else {
                        change.teuMaxError = '';
                    }

                    if (value && (value < 50 || value > 30000)) {
                        change.teuMaxError = '50 - 30000';
                    }
                    break;
                case 'linerMeterMin':
                    if (_tcOrder.vesselRequirements.linerMeterMax && value > _tcOrder.vesselRequirements.linerMeterMax) {
                        change.linerMeterMinError = 'Min is greater than max';
                    } else if (value < _tcOrder.vesselRequirements.linerMeterMax) {
                        change.linerMeterMinError = '';
                        change.linerMeterMaxError = '';
                    } else {
                        change.linerMeterMinError = '';
                    }
                    break;
                case 'linerMeterMax':
                    if (value < _tcOrder.vesselRequirements.linerMeterMin) {
                        change.linerMeterMaxError = 'Max is less than min';
                    } else if (value > _tcOrder.vesselRequirements.linerMeterMin) {
                        change.linerMeterMaxError = '';
                        change.linerMeterMinError = '';
                    } else {
                        change.linerMeterMaxError = '';
                    }
                    break;
                case 'ageMin':
                    if (_tcOrder.vesselRequirements.ageMax && value > _tcOrder.vesselRequirements.ageMax) {
                        change.ageMinError = 'Min is greater than max';
                    } else if (value < _tcOrder.vesselRequirements.ageMax) {
                        change.ageMinError = '';
                        change.ageMaxError = '';
                    } else {
                        change.ageMinError = '';
                    }
                    break;
                case 'ageMax':
                    if (value < _tcOrder.vesselRequirements.ageMin) {
                        change.ageMaxError = 'Max is less than min';
                    } else if (value > _tcOrder.vesselRequirements.ageMin) {
                        change.ageMaxError = '';
                        change.ageMinError = '';
                    } else {
                        change.ageMaxError = '';
                    }
                    break;
                default:
                    break;
                }

                that.setState(change);
            }

            _tcOrder.vesselRequirements = {
                ...(_tcOrder.vesselRequirements),
                [field]: value === '' ? null : value,
            };
        });

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    changeGearsGrabs = (changes) => {
        let vesselRequirements = _.cloneDeep(this.props.tcOrder.vesselRequirements);

        if (!Array.isArray(changes)) {
            changes = [changes];
        }
    
        const toChange = [];

        changes.forEach(({ field, value, type }) => {
            const tcField = field.split('[')[0];

            if (type === 'number') {
                value = parseFloat(value);
            }

            vesselRequirements = _.set(vesselRequirements, field, value);

            toChange.push({ field: tcField, value: vesselRequirements[tcField] });
        });

        this.changeField(toChange);
    }

    changeFlag = (field = 'flag', value) => {
        this.setState({
            selectedCountry: {
                ...this.state.selectedCountry,
                [field]: value,
            },
        });
    }

    addFlag = () => {
        const flags = _.cloneDeep(this.props.tcOrder.vesselRequirements.flags);

        const exists = flags.find(flag => flag.flag._id === this.state.selectedCountry.flag._id); 

        if (!exists && this.state.selectedCountry.flag._id) {
            flags.push(this.state.selectedCountry);

            this.changeField([{ field: 'flags', value: flags }]);
        }

        this.setState({
            selectedCountry: defaultSelectedCountry,
        });
    }

    deleteFlag = (index) => {
        const flags = _.cloneDeep(this.props.tcOrder.vesselRequirements.flags);
        flags.splice(index, 1);
        this.changeField([{ field: 'flags', value: flags }]);
    };

    /**
     * 
     * @param {*} field 
     * @param {*} value 
     * @param {*} label 
     * @param {(...e: any[])=>void} [onChange] 
     * @param {*} [disabled] 
     * @returns 
     */
    renderSelectFitted(field, value, label, onChange, disabled = false) {
        const _onChange = (e, i, _value) => {
            if (onChange) {
                return onChange(e, i, _value);
            } 
            return this.changeField([{ field, value: _value }]);
        };
        return (
            <SelectField
                value={value}
                onChange={_onChange}
                disabled={disabled}
                name={field}
                floatingLabelText={label}
                floatingLabelStyle={{ fontSize: '13px' }}
                autoWidth
                fullWidth
            >
                <MenuItem value={null} primaryText={undefined} />
                <MenuItem value primaryText='Yes' />
                <MenuItem value={false} primaryText='No' />
            </SelectField>
        );
    }

    render() {
        const { 
            vesselRequirements: { 
                dwtMin, dwtMax, capacityMin, capacityMax, typeByPurpose, typeBySpecialty, typeByConstruction,
                iceClass, ageMax, ageMin, boxShaped, openHatch, flags, geared, gearV2, grabbed, grabV2, co2Fitted,
                a60BulkheadFitted, cementHolesFitted, itfFitted, logsFitted, forHeavyCargoes, strengthenHeavy, lakesFitted, aussieFitted,
                ventilationFitted, ventilationType, imoFitted, imoApp, imoClass, referPlugFitted, referPlugQuantity, typeSizes, teuMin, teuMax,
                linerMeterMin, linerMeterMax, loaMax, beamMax, draftMax, piClubMember, scrubberFitted, referPlugsAmount,
            }, 
        } = this.props.tcOrder;
        const {
            selectedCountry, dwtMinError, dwtMaxError, capacityMinError, capacityMaxError, teuMinError, teuMaxError, 
            linerMeterMinError, linerMeterMaxError, ageMinError, ageMaxError,
        } = this.state; 
        const linerMeterDisabled = !(new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty));
        const teuDisabled = !['MPP', 'CONT'].includes(typeByPurpose); 

        return (
            <div>
                <div className='row'>
                    <div className='col-xs-12'>
                        <br />
                        <VesselTypesSelector typeSizes={typeSizes} changeField={this.changeField} />
                    </div>
                </div>
                <div className='row' style={{ display: 'flex' }}>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='dwtMin'
                            floatingLabelText='DWT min*'
                            required
                            value={dwtMin || ''}
                            onChange={e => this.changeField([{ field: 'dwtMin', value: parseFloat(e.target.value) }])}
                            fullWidth
                            floatingLabelStyle={dwtMinError ? { color: '#f44336' } : {}}
                            className={dwtMinError && 'hasValidationError'}
                            errorText={dwtMinError}
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='dwtMax'
                            floatingLabelText='DWT max*'
                            value={dwtMax || ''}
                            onChange={e => this.changeField([{ field: 'dwtMax', value: parseFloat(e.target.value) }])}
                            fullWidth
                            required
                            floatingLabelStyle={dwtMaxError ? { color: '#f44336' } : {}}
                            className={dwtMaxError && 'hasValidationError'}
                            errorText={dwtMaxError}
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='capacityMin'
                            type="number"
                            floatingLabelText='Capacity min'
                            value={capacityMin || ''}
                            onChange={e => this.changeField([{ field: 'capacityMin', value: parseFloat(e.target.value) }])}
                            fullWidth
                            required
                            floatingLabelStyle={capacityMinError ? { color: '#f44336' } : {}}
                            className={capacityMinError && 'hasValidationError'}
                            errorText={capacityMinError}
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='capacityMax'
                            floatingLabelText='Capacity max'
                            type="number"
                            value={capacityMax || ''}
                            onChange={e => this.changeField([{ field: 'capacityMax', value: parseFloat(e.target.value) }])}
                            fullWidth
                            floatingLabelStyle={capacityMaxError ? { color: '#f44336' } : {}}
                            className={capacityMaxError && 'hasValidationError'}
                            errorText={capacityMaxError}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3 flexed'>
                        <TypeByPurpose
                            type={typeByPurpose}
                            changeField={this.changeField}
                            fromTcOrder
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TypeBySpecialty
                            typeBySpecialty={typeBySpecialty}
                            changeField={this.changeField}
                            typeByPurpose={typeByPurpose}
                            fromTcOrder
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TypeByConstruction
                            type={typeByConstruction}
                            changeField={this.changeField}
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <SelectField 
                            value={iceClass}
                            onChange={(_e, _i, value) => this.changeField([{ field: 'iceClass', value }])}
                            name='iceClass'
                            floatingLabelText='Ice Class'
                            fullWidth
                            autoWidth
                        >
                            {
                                iceClassNames.map((iceClassName, index) => (
                                    <MenuItem
                                        key={index}
                                        value={iceClassName || ''}
                                        primaryText={iceClassName}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row' style={{ alignItems: 'end' }}>
                    <div className='col-xs-3 flexed'>
                        <TextField 
                            name='teuMin'
                            floatingLabelText='Teu min, m'
                            value={teuMin || ''}
                            onChange={e => this.changeField([{ field: 'teuMin', value: parseFloat(e.target.value) }])}
                            disabled={teuDisabled}
                            type='number'
                            floatingLabelStyle={teuMinError ? { color: '#f44336' } : {}}
                            errorText={teuMinError}
                            className={teuMinError && 'hasValidationError'}
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField 
                            name='teuMax'
                            floatingLabelText='Teu max, m'
                            value={teuMax || ''}
                            onChange={e => this.changeField([{ field: 'teuMax', value: parseFloat(e.target.value) }])}
                            disabled={teuDisabled}
                            type='number'
                            floatingLabelStyle={teuMaxError ? { color: '#f44336' } : {}}
                            errorText={teuMaxError}
                            className={teuMaxError && 'hasValidationError'}
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField 
                            name='linerMeterMin'
                            floatingLabelText='Liner meter min, m'
                            value={linerMeterMin || ''}
                            onChange={e => this.changeField([{ field: 'linerMeterMin', value: parseFloat(e.target.value) }])}
                            disabled={linerMeterDisabled}
                            type='number'
                            floatingLabelStyle={linerMeterMinError ? { color: '#f44336' } : {}}
                            errorText={linerMeterMinError}
                            className={linerMeterMinError && 'hasValidationError'}
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField 
                            name='linerMeterMax'
                            floatingLabelText='Liner meter max, m'
                            value={linerMeterMax || ''}
                            onChange={e => this.changeField([{ field: 'linerMeterMax', value: parseFloat(e.target.value) }])}
                            disabled={linerMeterDisabled}
                            type='number'
                            floatingLabelStyle={linerMeterMaxError ? { color: '#f44336' } : {}}
                            errorText={linerMeterMaxError}
                            className={linerMeterMaxError && 'hasValidationError'}
                            fullWidth
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='loaMax'
                            floatingLabelText='LOA max, m'
                            value={loaMax || ''}
                            onChange={e => this.changeField([{ field: 'loaMax', value: parseFloat(e.target.value) }])}
                            type='number'
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='beamMax'
                            floatingLabelText='Beam max, m'
                            value={beamMax || ''}
                            onChange={e => this.changeField([{ field: 'beamMax', value: parseFloat(e.target.value) }])}
                            type='number'
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='draftMax'
                            floatingLabelText='Draft max, m'
                            value={draftMax || ''}
                            onChange={e => this.changeField([{ field: 'draftMax', value: parseFloat(e.target.value) }])}
                            type='number'
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        { this.renderSelectFitted(fitted.boxShaped, boxShaped, 'Box shaped') }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='ageMin'
                            floatingLabelText='Age min'
                            value={ageMin || ''}
                            onChange={e => this.changeField([{ field: 'ageMin', value: parseFloat(e.target.value) }])}
                            floatingLabelStyle={ageMinError ? { color: '#f44336' } : {}}
                            errorText={ageMinError}
                            className={ageMinError && 'hasValidationError'}
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        <TextField
                            name='ageMax'
                            floatingLabelText='Age max'
                            value={ageMax || ''}
                            onChange={e => this.changeField([{ field: 'ageMax', value: parseFloat(e.target.value) }])}
                            floatingLabelStyle={ageMaxError ? { color: '#f44336' } : {}}
                            errorText={ageMaxError}
                            className={ageMaxError && 'hasValidationError'}
                            fullWidth
                        />
                    </div>
                    <div className='col-xs-3 flexed' style={styles.checkbox}>
                        <Checkbox
                            label="PI Club"
                            checked={!!piClubMember}
                            onCheck={() => this.changeField([{ field: 'piClubMember', value: !piClubMember }])}
                        />
                    </div>
                    <div className='col-xs-3 flexed'>
                        { this.renderSelectFitted(fitted.openHatch, openHatch, 'Open hatch') }
                    </div>
                </div>
                <RegisterClassMulti 
                    numberOrderTable={this.props.numberOrderTable} 
                    tcOrder={this.props.tcOrder} 
                />
                <div className='row'>
                    <div className='col-xs-8'>
                        <Flag
                            changeAutoComplete={
                                this.changeFlag
                            }
                            flagObject={selectedCountry.flag}
                        />
                    </div>
                    <div className='col-xs-2' style={styles.checkbox}>
                        <Checkbox
                            label="Excluded"
                            checked={!!selectedCountry.excluded}
                            onCheck={() => this.changeFlag('excluded', !selectedCountry.excluded)}
                        />
                    </div>
                    <div className='col-xs-2' style={styles.add}>
                        <IconButton>
                            <ContentAddIcon
                                onClick={() => {
                                    this.addFlag();
                                }}
                                color='green'
                            />
                        </IconButton>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12' style={{ display: 'flex', flexFlow: 'wrap' }}>
                        {
                            flags && flags.map((flag, index) => (
                                <Chip
                                    key={`flags_inc_exc_${index}`}
                                    onRequestDelete={() => this.deleteFlag(index)}
                                    style={{ ...styles.chips, backgroundColor: flag.excluded ? '#e6e6e6' : '#d6edbd' }}
                                >
                                    {flag.excluded && '- '}{flag.flag.name}
                                </Chip>
                            ))
                        }
                    </div>
                </div>
                <hr style={{ opacity: '0.2', marginTop: '20px' }} />
                <div className='row' style={{ height: '60px' }} >
                    <div className='col-xs-1'>
                        <span className='name-block static huge-name'>GEAR:</span>
                    </div>
                    <div className="col-xs-3 col-xs-offset-8" >
                        <GearedGrabbed 
                            confirmed
                            modifiedFields={null}
                            fieldName='geared'
                            gearedGrabbed={geared}
                            onChange={value => this.changeField([
                                { field: 'geared', value },
                                !value ? { field: 'grabbed', value } : { field: null },
                                !value ? { field: 'gearV2.summary', value: [{}] } : { field: null },
                                !value ? { field: 'grabV2.summary', value: [{}] } : { field: null },
                            ])}
                            styles={styles}                                
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12'>
                        <GearV2
                            gearV2={gearV2 || defaultGearV2}
                            changeField={val => this.changeGearsGrabs(val)}
                            fromTc
                        />
                    </div>
                </div>
                <hr style={{ opacity: '0.2', marginTop: '20px' }} />
                <div className='row' style={{ height: '60px' }} >
                    <div className='col-xs-1' style={{ marginTop: '20px' }}>
                        <span className='name-block static huge-name'>GRABS:</span>
                    </div>
                    <div className='col-xs-offset-8 col-xs-3'>
                        <GearedGrabbed 
                            confirmed
                            modifiedFields={null}
                            fieldName='grabbed'
                            gearedGrabbed={grabbed}
                            onChange={value => this.changeField([
                                { field: 'grabbed', value },
                                !value ? { field: 'grabV2.summary', value: [{}] } : { field: null },
                            ])}
                            styles={styles}                                
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12'>
                        <GrabV2
                            grabs={grabV2 || defaultGrabV2}
                            changeField={val => this.changeGearsGrabs(val)}
                            fromTc
                        />
                    </div>
                </div>
                <hr style={{ opacity: '0.2', marginTop: '20px' }} />
                <div className='row'>
                    <div className='col-xs-12' style={{ marginTop: '20px' }}>
                        <span className='name-block static huge-name'>TECHNICAL EQUIPMENT / CERTIFICATE:</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-4' style={styles.checkbox}>
                        { this.renderSelectFitted(fitted.co2Fitted, co2Fitted, 'CO2Fitted') }
                    </div>
                    <div className='col-xs-4' style={styles.checkbox}>
                        { this.renderSelectFitted(fitted.a60BulkheadFitted, a60BulkheadFitted, 'A60 bulkhead fitted') }
                    </div>
                    <div className='col-xs-4' style={styles.checkbox}>
                        { this.renderSelectFitted(fitted.cementHolesFitted, cementHolesFitted, 'Cement holes fitted') }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-4'>
                        { this.renderSelectFitted(fitted.itfFitted, itfFitted, 'Itf fitted') }
                    </div>
                    <div className='col-xs-4'>
                        { this.renderSelectFitted(fitted.logsFitted, logsFitted, 'Logs fitted') }
                    </div>
                    <div className='col-xs-4'>
                        { 
                            this.renderSelectFitted(
                                fitted.forHeavyCargoes, 
                                forHeavyCargoes, 
                                'Strengthened heavy',
                                () => {
                                    this.changeField([
                                        { field: 'strengthenHeavy', value: !strengthenHeavy },
                                        { field: 'forHeavyCargoes', value: !forHeavyCargoes },
                                    ]);
                                },
                            )
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-4'>
                        { this.renderSelectFitted(fitted.lakesFitted, lakesFitted, 'Lakes fitted') }
                    </div>
                    <div className='col-xs-4'>
                        { this.renderSelectFitted(fitted.aussieFitted, aussieFitted, 'Aussie fitted') }
                    </div>
                    <div className='col-xs-4'>
                        { this.renderSelectFitted(fitted.scrubberFitted, scrubberFitted, 'Scrubber fitted') }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-4'>
                        { 
                            this.renderSelectFitted(
                                fitted.ventilationFitted, 
                                ventilationFitted, 
                                'Ventilation fitted',
                                (e, i, _value) => this.changeField([
                                    { field: fitted.ventilationFitted, value: _value },
                                    !_value ? { field: 'ventilationType', value: '' } : {},
                                ]),
                            ) 
                        }
                    </div>
                    <div className='col-xs-5'>
                        <SelectField 
                            value={ventilationType}
                            onChange={(_e, _i, value) => {
                                this.changeField([
                                    { field: 'ventilationType', value }, 
                                ]);
                            }}
                            disabled={!ventilationFitted}
                            name='ventilationType'
                            floatingLabelText='Ventilation'
                            fullWidth
                            autoWidth
                        >
                            <MenuItem key='electrical' value='electrical' primaryText='Electrical' />
                            <MenuItem key='natural' value='natural' primaryText='Natural' />
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-4'>
                        { 
                            this.renderSelectFitted(
                                fitted.imoFitted, 
                                imoFitted, 
                                'Imo fitted',
                                (_e, _i, _value) => this.changeField([
                                    { field: fitted.imoFitted, value: _value },
                                    !_value ? { field: 'imoApp', value: '' } : {},
                                    !_value ? { field: 'imoClass', value: '' } : {},
                                ]),
                            )
                        }
                    </div>
                    <div className='col-xs-3'>
                        <SelectField 
                            value={imoApp}
                            onChange={(_e, _i, value) => this.changeField([
                                { field: 'imoApp', value }, 
                                { field: 'imoFitted', value: true },
                            ])}
                            disabled={!imoFitted}
                            name='imoApp'
                            floatingLabelText='Imo app'
                            fullWidth
                            autoWidth
                        >
                            {
                                imoAppNames.map((imoAppName, index) => (
                                    <MenuItem 
                                        key={`imoApp_${index}`} 
                                        value={imoAppName} 
                                        primaryText={imoAppName} 
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div className='col-xs-2'>
                        <SelectField 
                            value={imoClass}
                            onChange={(_e, _i, value) => this.changeField([{ field: 'imoClass', value }])}
                            name='imoClass'
                            disabled={!imoFitted}
                            floatingLabelText='Imo class'
                            fullWidth
                            autoWidth
                        >
                            {
                                imoClassNames.map((imoClassName, index) => (
                                    <MenuItem 
                                        key={`imoClass_${index}`} 
                                        value={imoClassName} 
                                        primaryText={imoClassName} 
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-4'>
                        { 
                            this.renderSelectFitted(
                                fitted.referPlugFitted, 
                                referPlugFitted, 
                                'Reefer plug fitted',
                                (_e, _i, _value) => this.changeField([
                                    { field: fitted.referPlugFitted, value: _value },
                                    !_value ? { field: 'referPlugsAmount', value: '' } : {},
                                    !_value ? { field: 'referPlugsQuantity', value: '' } : {},
                                ]),
                            )
                        }
                    </div>
                    <div className='col-xs-5'>
                        <TextField 
                            value={referPlugsAmount || ''}
                            onChange={e => this.changeField([
                                { field: 'referPlugsAmount', value: parseFloat(e.target.value) }, 
                                { field: 'referPlugsQuantity', value: parseFloat(e.target.value) }, 
                            ])}
                            disabled={!referPlugFitted}
                            name='referPlugsAmount'
                            floatingLabelText='Quantity'
                            fullWidth
                            type='number'
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default memo(connect(
    ({ tcOrders: { items: tcOrders }, countries }) => ({
        countries: countries && countries.items,
        tcOrders,
    }),
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(VesselRequirements));
class VesselTypesSelector extends React.PureComponent {
    state = {
        selected: this.props.typeSizes && this.props.typeSizes.length > 0 ? 'vessel_type' : 'dwt',
    };

    changeSelected = (selected) => {
        this.setState({ selected });

        if (selected === 'dwt') {
            this.props.changeField([{ field: 'typeSizes', value: [] }]);
        }
    }

    addTypeSize = (e, i, value) => {
        const typeSizesValue = [...new Set([...this.props.typeSizes, value])];

        this.props.changeField([{ field: 'typeSizes', value: typeSizesValue }, ...this.calculateMinMax(typeSizesValue)]);
    }

    removeTypeSize = (typeSize) => {
        const typeSizesValue = this.props.typeSizes.filter(t => t !== typeSize);

        this.props.changeField([{ field: 'typeSizes', value: typeSizesValue }, ...this.calculateMinMax(typeSizesValue)]);
    }

    calculateMinMax = (typeSizesArr) => {
        if (typeSizesArr.length > 0) {
            const firstTypeSize = VesselTypeSizes.find(v => Object.keys(v)[0] === typeSizesArr[0]);
            const lastTypeSize = VesselTypeSizes.find(v => Object.keys(v)[0] === typeSizesArr[typeSizesArr.length - 1]);
    
            return [
                { field: 'dwtMin', value: firstTypeSize[Object.keys(firstTypeSize)[0]].min },
                { field: 'dwtMax', value: lastTypeSize[Object.keys(lastTypeSize)[0]].max },
            ];
        } 
        return [];
    }

    render() {
        const { selected, selectedType } = this.state;
        const { typeSizes } = this.props;

        let typeSizesToShow = [];

        const indexOfLast = typeSizes.length - 1;
        if (indexOfLast >= 0) {
            const indexOfType = VesselTypeSizes.findIndex(v => Object.keys(v)[0] === typeSizes[indexOfLast]);
            typeSizesToShow = VesselTypeSizes.slice(indexOfType + 1);
        } else {
            typeSizesToShow = _.cloneDeep(VesselTypeSizes);
        }

        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-xs-6'>
                        <RadioButtonGroup
                            name="shipSelector" 
                            defaultSelected={selected}
                            style={styles.redioGroup}
                            onChange={(_t, selected) => this.changeSelected(selected)}
                        >
                            <RadioButton
                                value="dwt"
                                label="DWT"
                                style={styles.radioButton}
                            />
                            <RadioButton
                                value="vessel_type"
                                label="Vessel Type"
                                style={styles.radioButton}
                            />
                        </RadioButtonGroup>
                    </div>
                    <div className='col-xs-6'>
                        {
                            selected === 'vessel_type' &&
                            <SelectField
                                value={selectedType}
                                onChange={(e, i, value) => this.addTypeSize(e, i, value)}
                                name='geared'
                                floatingLabelText="Vessel type"
                                style={{ marginTop: '-40px' }}
                                fullWidth
                                autoWidth
                            >
                                {
                                    typeSizesToShow && typeSizesToShow.map((vesselType, index) => (
                                        <MenuItem 
                                            key={`vesselType_${index}`}
                                            value={Object.keys(vesselType)[0]} 
                                            primaryText={Object.keys(vesselType)[0]} 
                                        />
                                    ))
                                }
                            </SelectField>
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12' style={{ display: 'flex', flexFlow: 'wrap' }}>
                        {
                            typeSizes && typeSizes.map((typeSize, index) => (
                                <Chip
                                    key={`typeSize_${index}`}
                                    onRequestDelete={() => this.removeTypeSize(typeSize)}
                                    style={{ ...styles.chips, backgroundColor: '#d6edbd' }}
                                >
                                    { typeSize }
                                </Chip>
                            ))
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx